// removed by extract-text-webpack-plugin
module.exports = {"Blackberry":"#333D47","Bronze":"#E8C776","sizeSM":"14px","surcharge":"G8af22e","valueBackground":"Ge84fd5"};